import { render } from "./UserForm.vue?vue&type=template&id=830a59f6&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import "./UserForm.vue?vue&type=style&index=0&id=830a59f6&scoped=true&lang=css"
import "./UserForm.vue?vue&type=style&index=1&id=830a59f6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830a59f6"]])

export default __exports__